export enum PersonType {
  ADMINISTRATOR = 1,
  MODERATOR = 2,
  USER = 3,
  REGION_ADMINISTRATOR = 4,
  ENROLL = 5
}



// WEBPACK FOOTER //
// ./src/app/common/enums/person-type.enum.ts